import styled from '@emotion/styled';
import { ModalCloseButton } from '..';

export const StyledModalCloseButton = styled(ModalCloseButton)`
  z-index: 10;
`;
